import {observable} from 'mobx';
import {evite} from 'evite';
import urls from 'urls';

const defaultWhatToBring = {
  items: [
    {name: '', quantity: '', placeholder: 'ex: chips', autofocus: true},
    {name: '', quantity: '', placeholder: 'ex: salsa'},
    {name: '', quantity: '', placeholder: 'ex: drinks'},
    {name: '', quantity: '', placeholder: 'ex: cups'},
  ],
  editing: false,
  allow_other_items: false,
  formWasEmptyOnSubmit: false,
  emptyRows: [],
};

export class WidgetStore {
  @observable accessor polls = [];

  @observable accessor whatToBrings = [JSON.parse(JSON.stringify(defaultWhatToBring))];

  constructor(initialData) {
    if (initialData.whatToBrings && initialData.whatToBrings.length) {
      const initialWhatToBrings = JSON.parse(JSON.stringify(initialData.whatToBrings));
      initialWhatToBrings[0].editing = true;
      this.whatToBrings = initialWhatToBrings;
    }
    if (initialData.polls && initialData.polls.length) {
      this.polls = initialData.polls;
    }
  }

  clearWtb() {
    this.whatToBrings.replace([JSON.parse(JSON.stringify(defaultWhatToBring))]);
  }

  createWtb() {
    return JSON.parse(JSON.stringify(defaultWhatToBring));
  }
}
